import * as React from 'react'

import { FormComponent } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TextArea from 'modules/core/components/Inputs/TextArea'
import i18n from 'modules/core/lib/i18n'

import AttendanceShiftUtils from 'modules/attendance/lib/utils/AttendanceShift'

interface Props {
  form: Form
  shifts: TimesheetPageShiftFragment[]
}

const ShiftObservationForm = ({ form, shifts }: Props) => {
  const id = String(form.get('id').value)
  const shift = shifts.find((shiftValue) => shiftValue.id === id)
  if (!shift) return <></>

  const shiftType = AttendanceShiftUtils.isFirstHalf(shift)
    ? i18n.t('clock_in.observations.modal.first_half')
    : i18n.t('clock_in.observations.modal.second_half')
  const label = `${shiftType}`

  return (
    <FormComponent padding="s8">
      <TextArea label={label} field={form.get('observations')} />
    </FormComponent>
  )
}

export default observer(ShiftObservationForm)
